import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/devicePolicies/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/devicePolicies/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/devicePolicies/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/devicePolicies/delete',
    method: 'post',
    data
  })
}

